<div [innerHTML]="errors" mat-dialog-content>
</div>

<button mat-button (click)="onClose()">Close</button>
